import { supTripOrgDateFun } from '../../../api/supportAdmin';
import errorHandle from '../../../utils/errorHandle';

export default async function fetchTripDates(selectedTrip, setTripDates, selectedType, setLoading) {
    setLoading(true);
    try {
        const type = selectedType === 'upcoming' ? 'next' : 'previous';
        const table = await supTripOrgDateFun(selectedTrip, 'trip', type);
        setTripDates(table.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}
